import React, { useState, useRef, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import ReCAPTCHA from 'react-google-recaptcha'
import ModalDialog from '../../../shared/components/modals/modal-dialog/modal-dialog'
import Input from '../../../shared/components/atoms/input-round/input-round'
import Button from '../../../shared/components/atoms/button/button'
import AuthService from '../../../shared/services/auth-service'
import { key } from '../../../shared/constants/reCaptcha'
import { baseSiteUrl } from '../../../shared/utils/siteUrl'
import './modal-login.scss'
import SocialMedia from '../../../shared/components/atoms/social-media/social-media'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

const PHONE_REGEX = /^-{0,1}\d+$/

const ModalLogin = ({ content, onClose, onSuccessAuth }) => {
  const { textoRegistroModalInicioSesion,
          imagenModalInicioSesion,
          enlaceRegistroModalInicioSesion,
        } = content
  const reCaptchaRef = useRef()
  const [isLoading, setIsLoading] = useState(false)
  const {
    register,
    handleSubmit,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm()

  const loginUser = async ({ email, password }) => {
    try {
      reCaptchaRef.current.execute()
      clearErrors()
      setIsLoading(true)

      const isCellphone = PHONE_REGEX.test(email)

      const payload = {
        email: isCellphone
          ? process.env.COUNTRY_PHONE_PREFIX + email
          : email.toLocaleLowerCase(),
        password: password,
        captcha: reCaptchaRef.current.getValue(),
      }
      const res = await AuthService.authentication(payload)

      if (res.status === 200) {
        localStorage.setItem(
          'TOKEN_INFO',
          JSON.stringify({
            accessToken: res.data.token.accessToken,
            expiresIn: res.data.token.expiresIn,
            idToken: res.data.token.idToken,
            tokenType: res.data.token.tokenType,
            refreshToken: res.data.token.refreshToken,
            email: res.data.email,
          })
        )
        const userInfo = await getUserInfo(res.data.token.idToken)
        localStorage.setItem('USER_INFO', JSON.stringify(userInfo))
        onSuccessAuth(userInfo)
      } else {
        setError('password', {
          type: 'api-validation',
          message: res.userMessage,
        })
      }
    } catch (e) {
      console.error(e)
    } finally {
      setIsLoading(false)
    }
  }

  const hanldeRedirectRegister = () => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'ga_event',
      category: 'V-Confident :: Muestra Gratis',
      action: 'Paso 2 :: Login',
      label: ' Regístrate aquí',
      value: '',
    })
    localStorage.setItem('isFromVConfident',true)
    window.location.href = baseSiteUrl + '/registro/'
  }

  const getUserInfo = async idToken => {
    const config = {
      headers: {
        Authorization: idToken,
      },
    }

    const res = await AuthService.sessionInfo(config)
    if (res.status === 200) {
      return res.data
    } else {
      throw new Error(res.userMessage)
    }
  }

  const handleReloadCaptcha = async () => {
    await reCaptchaRef.current.execute()
  }

  useEffect(() => {
    reCaptchaRef.current.execute()
    let intervalCaptcha = setTimeout(
      setInterval(handleReloadCaptcha, 120000),
      110000
    )

    return () => {
      clearInterval(intervalCaptcha)
    }
  }, [])

  return (
    <ModalDialog
      onClose={onClose}
      isLoginModal={true}
      content={
        <div className="f-modal-login">
          <SocialMedia className="f-modal-social-media"/>
          <div className="f-modal-login-register">
            <p className="f-modal-login-register__description">
              {textoRegistroModalInicioSesion}
            </p>
            <GatsbyImage
              objectFit="contain"
              alt={imagenModalInicioSesion.description}
              image={getImage(imagenModalInicioSesion)}
              className="f-modal-login-register__image"
            />
            <a
              className="f-modal-login-register__redirect"
              onClick={e => {
                e.preventDefault()
                hanldeRedirectRegister()
              }}
              href={baseSiteUrl + '/registro/'}
            >{enlaceRegistroModalInicioSesion}</a>
          </div>
          <div className="f-modal-login-form">
            <ReCAPTCHA ref={reCaptchaRef} size="invisible" sitekey={key} />
            <h1 className="f-modal-login__title">
              Para solicitar una muestra de nuestro kit V-Confident Nosotras,
              <b> debes ingresar a tu cuenta o registrarte </b>
            </h1>
            <p className="f-modal-login__description">
              Ingresa el <b>correo</b> con el cual estás registrada en
              NosotrasOnline.com
            </p>
            <form
              className="f-login-form"
              onSubmit={handleSubmit(values => {
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                  event: 'ga_event',
                  category: 'V-Confident :: Muestra Gratis',
                  action: 'Paso 2 :: Login',
                  label: 'Iniciar sesión',
                  value: '',
                })
                loginUser(values)
              })}
            >
              <Input
                register={register('email')}
                errors={errors}
                placeholder="Correo electrónico"
              />
              <Input
                register={register('password')}
                errors={errors}
                placeholder="Contraseña"
                type="password"
              />
              <a
                className="f-login-form__recover"
                href={baseSiteUrl + '/login/recuperar/'}
              >
                ¿Olvidaste tu contraseña?
              </a>
              <Button
                text="Iniciar sesión"
                className="f-login-form__button"
                color="pink"
                isLoading={isLoading}
              />
            </form>
          </div>
        </div>
      }
    />
  )
}

export default ModalLogin
